export default __webpack_public_path__ + "static/media/ic-background.420899cb.png";